// Healer list from GET /admin/users/healers (item 168).
// The route answers { success, count, data: [...] }. Anything else gives [] so a page never crashes on shape.
export function healersFromResponse(res) {
  const list = res && res.data && res.data.data;
  return Array.isArray(list) ? list : [];
}
